import { SITE } from "@/constants/testIds";

// Each image: rotate (in degrees) is a CSS correction applied when the source
// file's EXIF orientation is missing/stripped. object-cover + rotate keeps
// the composition centered in the portrait card.
const images = [
  {
    url: "/images/gallery-1.jpeg",
    alt: "Student casting to the river on a bright summer morning",
    rotate: 0,
  },
  {
    url: "/images/gallery-2.webp",
    alt: "Student and Mike casting side by side on the riverbank",
    rotate: 0,
  },
  {
    url: "/images/gallery-3.webp",
    alt: "Angler wading a boulder-strewn river with a fly rod",
    rotate: 90,
  },
  {
    url: "/images/gallery-4.jpeg",
    alt: "Mike laughing with a student holding a fly rod on the river",
    rotate: 0,
  },
  {
    url: "/images/gallery-5.webp",
    alt: "Three friends grinning after a morning on the water",
    rotate: 180,
  },
];

export default function Gallery() {
  return (
    <section
      data-testid={SITE.gallery}
      className="relative bg-brand-cream py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="text-xs uppercase tracking-[0.35em] text-brand-evergreen/60">
              On the water
            </span>
            <h2 className="mt-3 font-display text-4xl leading-tight text-brand-evergreen sm:text-5xl lg:text-6xl">
              A small gallery of quiet mornings
            </h2>
          </div>
          <p className="max-w-md text-base text-brand-charcoal/65">
            Sunrise on the Rogue, the slow swing of a line, a student&rsquo;s
            first cast.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 sm:gap-5 md:grid-cols-3 md:gap-6 lg:grid-cols-5">
          {images.map((img, idx) => {
            const rot = img.rotate || 0;
            const quarter = rot === 90 || rot === -90 || rot === 270;
            // Quarter turns flip aspect ratio → source landscape (4:3) becomes
            // portrait (3:4). We scale up so the rotated image covers the
            // portrait card without letterboxing.
            const scale = quarter ? 1.34 : 1;
            return (
              <figure
                key={img.url}
                data-testid={SITE.galleryItem(idx)}
                className="group relative aspect-[3/4] overflow-hidden rounded-2xl bg-brand-evergreen/5 ring-1 ring-brand-evergreen/10"
              >
                <img
                  src={img.url}
                  alt={img.alt}
                  loading="lazy"
                  style={{
                    transform: `rotate(${rot}deg) scale(${scale})`,
                    transformOrigin: "center",
                  }}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-evergreen/30 via-transparent to-transparent opacity-60 transition-opacity group-hover:opacity-30" />
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
